import {
  Interpolation,
  CSSObject, StyledObject,
} from 'styled-components';
import { css } from 'styled-components';

import { ExecutionContext } from 'styled-components';

// typing is suboptimal here – see https://github.com/styled-components/styled-components/issues/4062

type ThemedStyledProps<P> = ExecutionContext & P;

export type MediaTypes = 'desktop' | 'tablet' | 'phone';

export const mediaSizes: { [key in MediaTypes]: number } = {
  desktop: 992,
  tablet: 768,
  phone: 595,
};

type MediaSC = {
  [key in MediaTypes]: <P extends object>(
    strings: CSSObject | TemplateStringsArray/* | InterpolationFunction<ThemedStyledProps<P>>*/,
    ...interpolations: Array<Interpolation<ThemedStyledProps<P>>>
  ) => Interpolation<ThemedStyledProps<P>>[];
};

export const media = Object.keys(mediaSizes).reduce<MediaSC>((acc, label) => {
  acc[label as MediaTypes] = <P>(first: StyledObject | TemplateStringsArray, ...interpolations: Array<Interpolation<ThemedStyledProps<P>>>) => css`
    @media (max-width: ${mediaSizes[label as MediaTypes]}px) {
      ${css(first, ...interpolations as Interpolation<object>[])}
    }
  `;
  return acc;
}, {} as MediaSC);
